
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import _ from 'lodash';
import TableGeneric from '@/components/NevronTableGeneric.vue';
import { SweetModal } from 'sweet-modal-vue';
import vPagination from '@/components/VuePlainPagination.vue';
import { showToaster } from '@/components/DashboardComposer/helpers';
import {manageTranslate, translate} from "../../helpers/functions";

@Component({
  methods: {manageTranslate, translate},
  components: {
    vPagination,
    SweetModal,
    TableGeneric,
  },
})
export default class CreateStays extends Vue {

  @Prop({ default: false })
  emitCreated!: boolean;

  stay = {
    customerId: null,
    checkinAt: null,
    checkoutAt: null,
    checkinTime: "12:00",
    checkoutTime: "",
    location: null,
    mainGuest: 1
  };

  stores = stores;

  response: any = null;
  items: IItem[] = [];

  searchQuery = '';
  resetSelected = false;
  loactions = [];

  mainCustomer: ICustomer | null = null;

  searchItems = _.debounce((res: any) => {
    this.fetchData();
  }, 400);

  created() {
    this.fetchData();
  }
  changeDate() {
    this.stay.checkoutTime = "10:00";
  }
  mounted() {
    stores.Customer.getCheckIn()
      .then((response) => {
        this.loactions = response.locations;
      });
    // if in customer show page, use that customer as main customer
    if (this.$route.name === 'customers.show' && this.$route.params.id) {
      // @ts-ignore
      this.stay.customerId = this.$route.params.id;
    }
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
    if (this.$route.name !== 'customers.show') {
      this.stay.customerId = null;
    }
    this.stay.checkinAt = null;
    this.stay.checkoutAt = null;
  }

  save() {
    if (this.stay.customerId) {
      stores.Stays.createNewItem(this.stay)
        .then((response: any) => {

          if (!response.success) {
            var body = Vue.prototype.translate(response.data?.errors?.checkoutAt[0]);
            var name = response.data?.message ? Vue.prototype.translate(response.data?.message) : Vue.prototype.translate(response.data?.message);

            if (body.length === 0) {
              body = response.data?.errors?.checkoutAt[0];
            }

            if (name.length === 0) {
              name = " ";
            }

            showToaster('danger', name, body, response.status, true);
            return
          }
          this.cancel();
          if (this.emitCreated) {
            this.$emit('created', response.data);
            return;
          }
          this.$router.push({ name: 'stays.show', params: { id: response.data.id } });
        });
    }
  }

  @Watch('response.currentPage')
  fetchData(index = 1) {
    return stores.Customer.fetchData!(index, this.searchQuery, 10)
      .then((response) => {
        this.response = response;
        this.items = response.data;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  pickADate() {
    if (!this.mainCustomer) {
      return;
    }
    // @ts-ignore
    this.stay.customerId = this.mainCustomer.id;
  }

}
